import React from "react";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import Row from "canvas-core-react/lib/Row";
import { TitleCustom } from "../../components/TitleCustom/TitleCustom";
import TextBody from "canvas-core-react/lib/TextBody";
import TextCaption from "canvas-core-react/lib/TextCaption";
import Card from "canvas-core-react/lib/Card";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import IconProduct from "../../assets/images/icon-product.svg";
import imgCheckbook from "../../assets/images/img-checkbook.png";
import imgCreditCard from "../../assets/images/img-credit-card.png";
import imgCurrentAccount from "../../assets/images/img-current-account.png";
import imgCreditLine from "../../assets/images/credit-line.svg";
import imgDebitCard from "../../assets/images/img-debit-card.png";
import { PrimaryButtonCustom } from "../../components/PrimaryButtonCustom/PrimaryButtonCustom";
import { useAppContext } from "../../context/AppContext";
import { WealthService } from "../../services/";
import { SecondaryButtonCustom } from "../../components/SecondaryButtonCustom/SecondaryButtonCustom";
import { formatAmount } from "../../utils/formatters";
import "./StepProducts.scss";

export const StepProducts = ({ changeContextClientStep }) => {
  const {
    state: context,
    changeItem: setContext,
    displayError,
  } = useAppContext();
  const wealthService = new WealthService();
  const getAgentSubject = async () => {
    await fetchAgentSubject();
    changeContextClientStep("planContracts");
  };

  const fetchAgentSubject = async () => {
    setContext({ loading: true });
    await wealthService
      .getAgentSubjectByCustomerSubject(context.subjectId)
      .then((res) => {
        setContext({
          agentSubject: res.subject_id,
        });
      })
      .catch((error) => {
        displayError(error);
      })
      .finally(() => {
        setContext({ loading: false });
      });
    setContext({ loading: false });
  };

  const getProductAmount = (code) => {
    let product = context.productsData.filter((items) => items.code === code);
    
    let amount = product[0].amount;
    let result = amount.filter((item) => item.currency === "CLP");
    console.log(result[0].amount)
    return result[0].amount;
  };

  return (
    <React.Fragment>
      <div className={"step-products"}>
        <TitleCustom
          image={<img src={IconProduct} alt="product" />}
          text="¡Estos son tus productos!"
        />
        <Margin id="infoProducts" lg={18} xs={18}>
          <Row className="align-items--center">
            <Column>
              <TextCaption id="nombre" component="p" bold>
                {context.subjectData.name}
              </TextCaption>
              <TextBody component="p" type="1">
                Por favor, confirma tus productos Scotia Wealth Management.
                Luego deberás aceptar las condiciones del contrato.
              </TextBody>
            </Column>
          </Row>
        </Margin>
        <Margin xs={12} sm={12} md={12} lg={12}>
          <Card>
            <Row style={{ marginLeft: "40px" }}>
              <Column lg={6} md={6} className={"content"}>
                <Margin
                    xs={[24, 0, 24, 0]}
                    sm={[24, 0, 24, 0]}
                    md={[24, 0, 24, 0]}
                    lg={[24, 0, 24, 0]}
                >
                  <div className={"box"}>
                    <div className={"box-img"}>
                      <img src={imgDebitCard} alt="img-debit-card" />
                    </div>
                    <div className={"box-content"}>
                      <TextSubtitle type="2" component="p">
                        Tarjeta de Débito
                      </TextSubtitle>
                    </div>
                  </div>
                </Margin>
              </Column>
              <Column lg={6} md={6} className={"content"}>
                <Margin
                    xs={[24, 0, 24, 0]}
                    sm={[24, 0, 24, 0]}
                    md={[24, 0, 24, 0]}
                    lg={[24, 0, 24, 0]}
                >
                  <div className={"box"}>
                    <div className={"box-img"}>
                      <img src={imgCreditCard} alt="img-credit-card" />
                    </div>
                    <div className={"box-content"}>
                      <TextSubtitle type="2" component="p">
                        Tarjeta de Crédito
                      </TextSubtitle>
                      <TextBody component="p" type="2">
                        {formatAmount(getProductAmount("VIWM"))}
                      </TextBody>
                    </div>
                  </div>
                </Margin>
              </Column>
            </Row>
            <Row style={{ marginLeft: "40px" }}>
              <Column lg={6} md={6} className={"content"}>
                <Margin
                    xs={[24, 0, 24, 0]}
                    sm={[24, 0, 24, 0]}
                    md={[24, 0, 24, 0]}
                    lg={[24, 0, 24, 0]}
                >
                  <div className={"box"}>
                    <div className={"box-img"}>
                      <img src={imgCreditLine} alt="img-credit-line" />
                    </div>
                    <div className={"box-content"}>
                      <TextSubtitle type="2" component="p">
                        Línea de Crédito
                      </TextSubtitle>
                      <TextBody component="p" type="2">
                        {formatAmount(getProductAmount("PE01"))}
                      </TextBody>
                    </div>
                  </div>
                </Margin>
              </Column>
              <Column lg={6} md={6} className={"content"}>
                <Margin
                    xs={[24, 0, 24, 0]}
                    sm={[24, 0, 24, 0]}
                    md={[24, 0, 24, 0]}
                    lg={[12, 0, 30, 0]}
                >
                  <div className={"box"}>
                    <div className={"box-img"}>
                      <img src={imgCurrentAccount} alt="img-current-account" />
                    </div>
                    <div className={"box-content"}>
                      <TextSubtitle
                          style={{ marginTop: "20px" }}
                          type="2"
                          component="p"
                      >
                        Cuenta Corriente
                      </TextSubtitle>
                    </div>
                  </div>
                </Margin>
              </Column>
            </Row>
            <Row>
              <Column className={"content"}>
                <Margin
                    xs={[24, 0, 24, 0]}
                    sm={[24, 0, 24, 0]}
                    md={[24, 0, 24, 0]}
                    lg={[24, 0, 24, 0]}
                >
                  <div className={"box-end"}>
                    <div className={"box-img"}>
                      <img src={imgCheckbook} alt="img-checkbook" />
                    </div>
                    <div className={"box-content"}>
                      <TextSubtitle
                          style={{ marginTop: "20px" }}
                          type="2"
                          component="p"
                      >
                        Cheques y porta chequera
                      </TextSubtitle>
                    </div>
                  </div>
                </Margin>
              </Column>
            </Row>
          </Card>
        </Margin>
        <Margin id="CardProducts" xs={36}>
          <Row>
            <Column>
              <Row className="align-items--center">
                <Column lg={2}>
                  <Margin lg={24} xs={6}>
                    <SecondaryButtonCustom
                      id={"button-volver"}
                      onClick={() =>
                        changeContextClientStep("stepSelectValidationOptions")
                      }
                      text="Volver"
                    />
                  </Margin>
                </Column>
                <Column lg={3} lgOffset={7}>
                  <Margin lg={24} xs={6}>
                    <PrimaryButtonCustom
                      id={"button-continuar"}
                      onClick={getAgentSubject}
                      text="Continuar"
                    />
                  </Margin>
                </Column>
              </Row>
            </Column>
          </Row>
        </Margin>
      </div>
    </React.Fragment>
  );
};
